var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flipper",class:_vm.classes},[_c('transition',{attrs:{"name":"flip"}},[_c('span',{key:`flip-${_vm.valueDisplay}`,staticClass:"flipper__value",style:(_vm.valueStyle)},[_vm._v(_vm._s(_vm.valueDisplay))])]),_vm._v(" "),_c('span',{staticClass:"flipper__sizer",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.valueDisplay))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }